import React, { createContext, useState, useEffect } from 'react';
import { getConfig } from "../api/configurationController.";
import Loader from '../components/atoms/Loader';
import { setApiVersionHeader } from '@api';

export const ConfigurationContext = createContext();

export const ConfigurationProvider = ({ children }) => {
  const [config, setConfig] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!config) {
      const fetchConfig = async () => {
        const data = await getConfig();
        setConfig(data);
        setApiVersionHeader(data.appVersion);
        setIsLoading(false);
      };
      fetchConfig();
    }
    else {
      setIsLoading(false);
    }
  }, [config]);

  if (isLoading) {
    return <Loader></Loader>;
  }

  return (
    <ConfigurationContext.Provider value={{ config, setConfig }}>
      {children}
    </ConfigurationContext.Provider>
  );
};


